module.exports = {
  animate (el) { // animate elemens as you scroll
    // console.log(el)
    var windowWidth = window.outerWidth
    // console.log(windowWidth)
    var paragraphEle = document.getElementsByClassName('in-viewport')
    // console.log(paragraphEle)
    if (windowWidth > 1024) {
      for (var a = 0; a < paragraphEle.length; a++) {
        // console.log(paragraphEle[a])
        if (paragraphEle[a].classList.contains('below-viewport')) {
          if (paragraphEle[a].classList.contains('imageSlider')) {
            var imageContainer = document.getElementById('rightWrap')
            var kids = imageContainer.childNodes
            kids[0].classList.add('INVIEW')
            kids[2].classList.add('INVIEW')
          } else if (paragraphEle[a].classList.contains('doubleImage')) {
            console.log('YAY YAY YAY')
            var doubleImages = paragraphEle[a].childNodes
            doubleImages[0].classList.add('INVIEW')
            doubleImages[1].classList.add('INVIEW')
          } else {
            // console.log('ready to move')
            window.Velocity(paragraphEle[a], { top: '0px' }, { duration: 800 })
          }
        }
      }
    }
  },
  animateCaseStudy () {
    /* setTimeout(function () {
      // fading in menu button
      var menuBtn = document.getElementById('menuBtn')
      menuBtn.classList.add('fadeIn')
      // fading in BSD logo
      var logoBtn = document.getElementById('bsdBtn')
      logoBtn.classList.add('fadeIn')
    }, 500) */

    var caseStudies = document.getElementById('wrap')

    setTimeout(function () {
      caseStudies.classList.add('fadeIn')
      var sliderOverlay = document.getElementsByClassName('overlay')
      var overlayChildren

      // running through each overlay and targetting the child nodes
      for (var b = 0; b < sliderOverlay.length; b++) {
        overlayChildren = sliderOverlay[b].childNodes

        for (var c = 0; c < overlayChildren.length; c++) {
          if (overlayChildren[c].textContent !== ' ') {
            overlayChildren[c].classList.add('fadeIn')
          }
        }
      }
    }, 2300)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/projectAnimation.js